import { render, staticRenderFns } from "./EditSessionDialog.vue?vue&type=template&id=3ef85340&scoped=true"
import script from "./EditSessionDialog.vue?vue&type=script&lang=ts"
export * from "./EditSessionDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditSessionDialog.vue?vue&type=style&index=0&id=3ef85340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef85340",
  null
  
)

export default component.exports